<template>
  <div class="platforms-page">
    <!-- <PreloaderPage /> -->

    <BannerPages
      :title="'platforms.titlebanner'"
      :descriptions="[
          $t('platforms.descriptbanner'),
      ]"
      :img="'/images/platform/Platforms-Img1.png'"
      mainImageWidthDesk="541"
      mainImageHeightDesk="530"
      alt="A platform selection to fit every need"
      :buttons="[
          {
              type: 'external',
              href: getExternalUrl('/register/1/live-account'),
              class: 'primary-button-medium',
              text: 'platforms.btn1' 
          },
          {
              type: 'external',
              href: getExternalUrl('/register/1/demo-account'),
              class: 'second-button-medium-white',
              text: 'platforms.btn2' 
          }
      ]"
    />

    <LazyPlataformFav class="var-platform slideX3" :dynamicTitle="'platforms.platformFav.titleTable'" />

    <div class="var-accountstailored" :style="degrade">
      <LazyAccountstailored
        :title="'platforms.titlesteps'"
        :description="'platforms.descriptionsteps'"
        :name_title="true"
        :items="filteredStepsItems"
      />
    </div>
    <LazydiscoverTransparent :style="degrade2"/>
    <LazyWhyChoose
      class="var-choose"
      :title="'platforms.why-choose.title'"
      :platformView="true"
    />
    <!-- <LazyWhyOthersLike title="platforms.why-others-like.title" /> -->
    <client-only>
      <LazyInvestment
        :label="'platforms.titleInvest'"
        :cont_descript2="true"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'investment.link'
          }
        ]"
      />
    </client-only>
  </div>
</template>
<script setup>
import LazyPlataformFav from "~/components/market/PlataformFav.vue";
import LazyAccountstailored from "~/components/market/Accountstailored.vue";
import LazyWhyChoose from "~/components/company/WhyChoose.vue";
import LazyWhyOthersLike from "~/components/company/WhyOthersLike.vue";
import LazyInvestment from "~/components/Investment";
import LazydiscoverTransparent from "~/components/platfroms/discoverTransparent.vue";
// import PreloaderPage from "~/components/PreloaderPage.vue";

import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports';


const { t, locale } = useI18n();
const { getExternalUrl } = useExternalUrl();
const { $regulationsVar } = useNuxtApp();

const regulation = ref($regulationsVar.getRegulation(locale.value));
const nuxtImg = useImage();

const title = t("seo.platform.title");
const description = t("seo.platform.description");
const imgSeo = 'https://tradeview.eu/images/seo/10Platforms.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/platform/Platforms-Gradient.avif';
const degradade2ImageUrl = '/images/platform/Platforms-Gradient-2.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradade2ImageUrl , {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

const degrade2 = computed(() => {
  return {
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});

let stepsItems = ref([
  {
    id: 1,
    icon: "emoji_objects",
    titledescription: "platforms.titleitem1",
    description: "platforms.descriptitem1",
    hiddenLocales: [],  
    showLocales: []  
  },
  {
    id: 2,
    icon: "devices",
    titledescription: "platforms.titleitem2",
    description: "platforms.descriptitem2",
    hiddenLocales: [],  
    showLocales: []  
  },
  {
    id: 3,
    icon: "compare_arrows",
    titledescription: "platforms.titleitem3",
    description: "platforms.descriptitem3",
    hiddenLocales: [],  
    showLocales: []  
  },
  {
    id: 4,
    icon: "arrow_selector_tool",
    titledescription: "platforms.titleitem4",
    description: "platforms.descriptitem4",
    hiddenLocales: [],  
    showLocales: []  
  },
  {
    id: 5,
    icon: "extension",
    titledescription: "platforms.titleitem5",
    description: "platforms.descriptitem5",
    hiddenLocales: [],  
    showLocales: []  
  },
  {
    id: 6,
    icon: "attach_money",
    titledescription: "platforms.titleitem6",
    description: "platforms.descriptitem6",
    hiddenLocales: [],  
    showLocales: []  
  },
  {
    id: 7,
    icon: "speed",
    titledescription: "platforms.titleitem7",
    description: "platforms.descriptitem7",
    hiddenLocales: [],  
    showLocales: [],  
    hiddenForRegulations: ['LATAM']
  },
  {
    id: 8,
    icon: "school",
    titledescription: "platforms.titleitem8",
    description: "platforms.descriptitem8",
    hiddenLocales: [],  
    showLocales: []   
  },
  {
    id: 9,
    icon: "phone_iphone",
    titledescription: "platforms.titleitem9",
    description: "platforms.descriptitem9",
    hiddenLocales: [],  
    showLocales: []  
  },
  {
    id: 10,
    icon: "clarify",
    titledescription: "platforms.titleitem10",
    description: "platforms.descriptitem10",
    hiddenLocales: [],  
    showLocales: []  
  },
]);

const filteredStepsItems = computed(() => {
  return stepsItems.value.filter(item => {
    const hideInCurrentLocale = item.hiddenLocales.includes(locale.value);
    const showInCurrentLocale = item.showLocales.length === 0 || item.showLocales.includes(locale.value);
    const hideForRegulation = item.hiddenForRegulations?.includes(regulation.value);
    return !hideInCurrentLocale && showInCurrentLocale && !hideForRegulation;
  });
});
</script>
